/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import Button from 'components/Button';
import AppleIcon from 'components/SvgIcons/Apple';
import GoogleIcon from 'components/SvgIcons/Google';
import { OAuthProviders, RegistrationConfig } from '../../interfaces/social-login';

import styles from './SocialLoginButtons.module.scss';

const SocialLoginButtons: React.FC = () => {
  const [registrationConfig, setRegistrationConfig] = useState<RegistrationConfig | null>({
    oauthProvidersEnabled: true,
    recaptchaEnabled: false,
    oauthProviders: [OAuthProviders.APPLE, OAuthProviders.GOOGLE],
  });

  useEffect(() => {
    // Hide apple login for Android devices
    if ((window as any).Android) {
      setRegistrationConfig({
        oauthProviders: [OAuthProviders.GOOGLE],
        oauthProvidersEnabled: true,
        recaptchaEnabled: false,
      });
    }
  }, []);

  const handleSocialLogin = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    const target = e.target as HTMLButtonElement;
    const provider = target.dataset.oauthprovider;
    const oauthProviderWindowFeatures =
      'menubar=no,location=yes,resizable=no,scrollbars=no,status=no,width=500,height=600';

    if ((window as any).webkit) {
      switch (provider) {
        case OAuthProviders.APPLE.toLowerCase():
          (window as any).webkit.messageHandlers.appleLogin.postMessage('Apple login');
          break;
        case OAuthProviders.GOOGLE.toLowerCase():
          (window as any).webkit.messageHandlers.googleLogin.postMessage('Google login');
          break;
        default:
          break;
      }

      return;
    }

    if ((window as any).Android) {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      Android.onGoogleLogin();

      return;
    }

    window.open(`/blaize/oauth/${provider}`, `${provider} sign-in`, oauthProviderWindowFeatures);
  };

  const renderIcon = (provider: OAuthProviders) => {
    switch (provider) {
      case OAuthProviders.APPLE:
        return <AppleIcon className={styles.icon} />;
      case OAuthProviders.GOOGLE:
        return <GoogleIcon className={styles.icon} />;
      default:
        return null;
    }
  };

  return (
    <div>
      {registrationConfig?.oauthProvidersEnabled &&
        registrationConfig?.oauthProviders.map(provider => (
          <Button
            key={provider}
            id={`btn-login-with-${provider.toLowerCase()}`}
            data-oauthprovider={provider.toLowerCase()}
            onClick={handleSocialLogin}
            variant="outlined"
            startIcon={renderIcon(provider)}
            fullWidth
          >
            {`Fortsett med ${provider}`}
          </Button>
        ))}
    </div>
  );
};

export default SocialLoginButtons;
